import { ReactionStatus } from '../types';
const compareEmojiId = (l, r) => {
  return l.localeCompare(r);
};
const sortByRelevance = (a, b) => {
  if (a.count > b.count) {
    return -1;
  } else if (a.count < b.count) {
    return 1;
  } else {
    return compareEmojiId(a.emojiId, b.emojiId);
  }
};
const sortByPreviousPosition = reactions => {
  const indexes = reactions.reduce((map, reaction, index) => {
    map[reaction.emojiId] = index;
    return map;
  }, {});
  const getPosition = ({
    emojiId
  }) => indexes[emojiId] === undefined ? reactions.length : indexes[emojiId];
  return (a, b) => getPosition(a) - getPosition(b);
};
export const readyState = reactions => ({
  status: ReactionStatus.ready,
  reactions: reactions.filter(reaction => reaction.count > 0)
});
export const byEmojiId = emojiId => reaction => reaction.emojiId === emojiId;
export const addOne = reaction => ({
  ...reaction,
  count: reaction.count + 1,
  reacted: true
});
export const removeOne = reaction => ({
  ...reaction,
  count: reaction.count - 1,
  reacted: false
});
export const updateByEmojiId = (emojiId, updater) => reaction => reaction.emojiId === emojiId ? updater instanceof Function ? updater(reaction) : updater : reaction;
export const getReactionsSortFunction = reactions => reactions && reactions.length ? sortByPreviousPosition(reactions) : sortByRelevance;
export const flattenAris = (a, b) => a.concat(b);
export function isRealErrorFromService(errorCode) {
  // we don't count 401 or 403 as a real error from services
  return !errorCode || !(errorCode === 401 || errorCode === 403);
}